module.exports = App.OrderBuddy = DS.Model.extend
  name:   DS.attr 'string'
  avatar: DS.attr 'string'

  is_owner: DS.attr 'boolean'

  items: DS.hasMany   'order_item', async: true
  order: DS.belongsTo 'order',      async: true

  avatarStyle: (->
    avatar = @get('avatar')
    result = if avatar then "background-image: url(#{avatar});" else ''
    result.htmlSafe()
  ).property('avatar')
